import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import FullScreenLoader from './full-screen';
import AssetKeyFormProp from './properties/asset-key-form';
import TokenMetaDataView from './token-metadata-view';
import {LoadingStatusEnum} from '../enums/LoadingStatusEnum';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function TokenUrlForm({
                          collectionId, setStatusMessage, handleClose, contract,
                      }: AssetKeyFormProp):
    React.ReactElement {
    const [loadingStatus, setLoadingStatus] = useState(LoadingStatusEnum.loaded);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');
    const [baseTokenUrl, setBaseTokenUrl] = useState('');

    function validateForm() {
        if (!baseTokenUrl || baseTokenUrl?.trim().length === 0) {
            setErrorMessage('Please enter token url id field');
            setSetErrorClass('error mb-4');
            return false;
        }

        setErrorMessage('');
        setSetErrorClass('hide');

        return true;
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            setLoadingStatus(LoadingStatusEnum.loading);
            SandraJsAPI.updateBaseTokenUrl({
                ...contract,
                baseTokenUrl: baseTokenUrl
            }, collectionId).then((res) => {
                if (res.error) {
                    setStatusMessage(res.error.message, StatusMessageTypeEnum.error);
                }
                {
                    setStatusMessage('Token url updated successfully, please reload the page.', StatusMessageTypeEnum.success);
                }
                setLoadingStatus(LoadingStatusEnum.loaded);
                handleClose(false, 'success');
                window.scrollTo(0, 0);
            }).catch((error) => {
                setStatusMessage(error.message, StatusMessageTypeEnum.error);
                setLoadingStatus(LoadingStatusEnum.loaded);
                handleClose(false, 'error');
                window.scrollTo(0, 0);
            });
        }
    };

    const handleStatusMessage = (message: string, type: string) => {
        if (type === 'error') {
            setErrorMessage(message);
            setSetErrorClass('error mb-4');
        } else {
            setErrorMessage('');
            setSetErrorClass('hide');
        }
    };

    useEffect(() => {
        setBaseTokenUrl(contract?.baseTokenUrl);
    }, []);

    return (
        <div className="rounded add-process-box">
            {loadingStatus === LoadingStatusEnum.loading ? <FullScreenLoader/> : <div/>}
            <h5 className="p-1 mb-2">Add/Update Base Token Url</h5>
            <div className={errorClass}>{errorMessage}</div>
            <div className="row">
                <div className="col-md-6">
                    <TokenMetaDataView
                        contract={contract}
                        setStatusMessage={handleStatusMessage}
                        onLoadingStatusChanged={
                            (status) => {
                                setLoadingStatus(status);
                            }
                        }
                    />
                </div>
                <div className="col-md-6">
                    <form onSubmit={handleSubmit}>
                        <h5>What is Base Token Url?</h5>
                        <p className="mb-3">
                            Its a base url that will be used to create token url from a token id.
                        </p>
                        <p className="">
                            Suppose metadata url for a contract with token id
                            {' '}
                            <b>2</b>
                            {' '}
                            is
                            <span className="fst-italic ms-1 me-1 text-decoration-underline">
                https://metadata.spellsofgenesis.com/sog-eth-askian/
                <b>2</b>
              </span>
                        </p>
                        <p>
                            You will need to replace the token id from from the url with #TOKEN#,
                            this information will
                            be unique for each contract/collection pair.
                            Jetski will replace #TOKEN# part from the base url
                            with respective token id information to create
                            actual url to get metadata.
                        </p>
                        <p className="">
                            Base token url for above url will be
                            <span className="fst-italic ms-1 me-1 text-decoration-underline">
                https://metadata.spellsofgenesis.com/sog-eth-askian/
                <b>#TOKEN#</b>
              </span>
                        </p>
                        <div className="mb-3">
                            <div>
                                <span className="me-2  form-label fw-bold"> Collection Id:</span>
                                <span>{collectionId}</span>
                            </div>
                        </div>
                        <label htmlFor="baseUrl" className="form-label w-100">
                            Base Token Url
                            <input
                                type="text"
                                id="baseUrl"
                                className="form-control mt-1 d-block"
                                value={baseTokenUrl}
                                onChange={(e) => {
                                    setBaseTokenUrl(e.target.value);
                                }}
                            />
                        </label>
                        <p className="mb-1">Possible token Url using above base url with token id 2 - </p>
                        <a
                            className="fst-italic mt-0 text-break"
                            style={{fontSize: '14px'}}
                            href={baseTokenUrl?.replace('#TOKEN#', '2')}
                        >
                            {baseTokenUrl?.replace('#TOKEN#', '2')}
                        </a>
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-dark me-2 ">Submit</button>
                            <Button className="btn btn-light " variant="primary" onClick={() => {
                                handleClose(false, 'close');
                            }}>
                                Close
                            </Button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
}

export default TokenUrlForm;
